import type { StateTree } from '@makemydeal/dr-dash-types';
import type { OfferType } from '@makemydeal/dr-platform-types';

// useSelector compares by reference, so an inline [] fallback would re-render on every action.
const NO_FIELDS: string[] = [];

export const getManualFieldOverrides = (state: StateTree): string[] => state.manualFieldOverrides?.fields ?? NO_FIELDS;

/**
 * Whether Auto Select Program is on for a deal type, or `undefined` when nothing has been recorded for it.
 * Callers must treat `undefined` as "fall back to that deal type's calculation endpoint".
 */
export const getIsAutoSelectChecked = (state: StateTree, offerType: OfferType): boolean | undefined =>
    state.manualFieldOverrides?.checkedByOfferType?.[offerType];

export const getAutoSelectDealerDefault = (state: StateTree, offerType: OfferType): boolean =>
    state.manualFieldOverrides?.dealerDefaultByOfferType?.[offerType] ?? false;

/**
 * What Auto Select is set to for a deal type: the user's recorded selection, else that deal type's dealer
 * default. Both are per deal type, and the default is a load-time snapshot, so this answer does not move
 * when a fallback moves the endpoint.
 */
export const getResolvedAutoSelectChecked = (state: StateTree, offerType: OfferType): boolean =>
    getIsAutoSelectChecked(state, offerType) ?? getAutoSelectDealerDefault(state, offerType);
